import { IS_CREATE_ORGANIZATION } from '../constants/LocalStorageConstants';
import { QueryParamPersistence } from './queryParamPersistence';

const FLOW_MODE_QUERY_PARAM = 'flowMode';
const FLOW_MODE_CREATE_ORGANIZATION = 'create-organization';
const LEGACY_PLAN_SELECTION_SOURCE_QUERY_PARAM = 'planSource';
const LEGACY_PLAN_SELECTION_SOURCE_ONBOARDING = 'onboarding';
const NEW_ORGANIZATION_PATH = '/organizations/new';

function appendOnboardingFlowQuery(path: string): string {
  return QueryParamPersistence.appendQueryParamsToPath(
    path,
    `${FLOW_MODE_QUERY_PARAM}=${FLOW_MODE_CREATE_ORGANIZATION}`,
  );
}

function hasCreateOrganizationFlowQuery(search: string): boolean {
  try {
    const params = new URLSearchParams(search);
    return (
      params.get(FLOW_MODE_QUERY_PARAM) === FLOW_MODE_CREATE_ORGANIZATION ||
      params.get(LEGACY_PLAN_SELECTION_SOURCE_QUERY_PARAM) ===
        LEGACY_PLAN_SELECTION_SOURCE_ONBOARDING
    );
  } catch {
    return false;
  }
}

export function isCreateOrganizationFlowActive(
  search: string = globalThis.location?.search ?? '',
): boolean {
  const hasSessionFlag =
    globalThis.sessionStorage?.getItem(IS_CREATE_ORGANIZATION) === 'true';

  return hasSessionFlag || hasCreateOrganizationFlowQuery(search);
}

export function appendCreateOrganizationFlowQuery(path: string): string {
  return appendOnboardingFlowQuery(path);
}

export function buildCreateOrganizationPath(
  isCreateOrganization: boolean = false,
): string {
  if (!isCreateOrganization) {
    return NEW_ORGANIZATION_PATH;
  }

  return appendCreateOrganizationFlowQuery(NEW_ORGANIZATION_PATH);
}

export function buildPlanSelectionPath(
  organizationId: string,
  isCreateOrganization: boolean = false,
): string {
  const basePath = `/organizations/${organizationId}/subscriptions/plan`;

  if (!isCreateOrganization) {
    return basePath;
  }

  return appendCreateOrganizationFlowQuery(basePath);
}

export function buildFlowAwarePlanSelectionPath(
  organizationId: string,
  search: string = globalThis.location?.search ?? '',
): string {
  const basePath = buildPlanSelectionPath(
    organizationId,
    isCreateOrganizationFlowActive(search),
  );

  if (!hasCreateOrganizationFlowQuery(search)) {
    return basePath;
  }

  return QueryParamPersistence.appendQueryParamsToPath(basePath, search);
}
